import { render, staticRenderFns } from "./WorkingoutHeader.vue?vue&type=template&id=63a5b710&scoped=true"
import script from "./WorkingoutHeader.vue?vue&type=script&lang=js"
export * from "./WorkingoutHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5b710",
  null
  
)

export default component.exports